(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  class NatureDecodeCollectionTabs extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.section-resource-list');
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
      if (tabs.length < 2 || panels.some((panel) => panel?.parentElement !== section)) return;

      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      const viewAll = section.querySelector('[data-nd-collection-view-all]');
      const viewAllLink = viewAll?.querySelector('a');
      let activeIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');

      const select = (index) => {
        if (index === activeIndex) return;

        const previousPanel = panels[activeIndex];
        const previousContent = document.createElement('template');
        previousContent.content.append(...previousPanel.childNodes);
        previousPanel.append(previousContent);
        previousPanel.hidden = true;
        tabs[activeIndex].setAttribute('aria-selected', 'false');
        tabs[activeIndex].tabIndex = -1;

        const tab = tabs[index];
        const panel = panels[index];
        panel.hidden = false;
        const content = panel.querySelector(':scope > template').content;
        panel.replaceChildren(content);
        tab.setAttribute('aria-selected', 'true');
        tab.tabIndex = 0;
        activeIndex = index;

        if (viewAllLink) {
          viewAllLink.href = tab.dataset.collectionUrl;
          viewAll.hidden = tab.dataset.showViewAll !== 'true';
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index), options);
        tab.addEventListener('keydown', (event) => {
          let nextIndex;
          const rtl = getComputedStyle(this).direction === 'rtl';
          switch (event.key) {
            case 'ArrowRight': nextIndex = index + (rtl ? -1 : 1); break;
            case 'ArrowLeft': nextIndex = index + (rtl ? 1 : -1); break;
            case 'Home': nextIndex = 0; break;
            case 'End': nextIndex = tabs.length - 1; break;
            default: return;
          }
          event.preventDefault();
          nextIndex = (nextIndex + tabs.length) % tabs.length;
          select(nextIndex);
          tabs[nextIndex].focus();
        }, options);
      });

      this.hidden = false;
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }
  }

  if (!customElements.get('nd-collection-tabs')) {
    customElements.define('nd-collection-tabs', NatureDecodeCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
